import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { computed, defineComponent, ref } from "vue"; //common

import { useI18n } from "vue-i18n"; // modules

import UserModule from "@/store/modules/user";
import POSConfigModule from "@/store/modules/pos-config"; // helpers

import { pushWithQuery, redirectToLoginPage } from "@/utils/helpers/router.helper";
import { dialogVisibleForStatus, hideDialog } from "@/utils/vue-helpers/modal";
import NotificationService from "@/services/notification.service"; // constants

import { ModalStatus } from "@/constants/modal";
import { RouteNames } from "@/constants/router"; // components

import { Spinner } from "@/components/index";
import AuthModule from "@/store/modules/auth";
import AppModule from "@/store/modules/app";
import DeviceModule from "@/store/modules/device";
import { LogService } from "@/services/logging";
import { ElMessageBox } from "element-plus/es/components/message-box";
import ModalModule from "@/store/modules/modal";
import BookingModule from "@/store/modules/booking";
import { hasNonEmptyBookings } from "@/utils/vue-helpers/booking";
import { proceedFetchAndStoreGroupPicture } from "@/utils/helpers/product-category";
import { NetworkErrors } from "@/constants/errors/network";
import { hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import { loadConfigData } from "@/utils/helpers/pos-config";
export default defineComponent({
  name: "PosConfiguration",
  components: {
    Spinner: Spinner
  },
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var loading = ref(true);
    var userGroupId = ref(UserModule.getUserGroupId);
    var configs = ref([]); // ref(ConfigurationModule.posConfigs);

    var modalVisibility = dialogVisibleForStatus(ModalStatus.PosConfig);
    var adminUserWithoutGroup = computed(function () {
      return UserModule.isAdminUserWithoutGroup;
    });
    var getLoadingText = computed(function () {
      return POSConfigModule.getLoadingText;
    });
    var progressValue = computed(function () {
      var pcsProgress = POSConfigModule.pcsLoaded;
      var timeslotsProgress = POSConfigModule.timeslotsLoaded;

      if (pcsProgress > 50 || timeslotsProgress) {
        // Cap PCs progress at 50 once timeslots start loading
        pcsProgress = 50;
      }

      if (timeslotsProgress > 35) {
        // Cap timeslots progress at 35
        timeslotsProgress = 35;
      } // extraProgress covers the remaining 5% (seating plans, promotions, offers, locations)


      return 10 + pcsProgress + timeslotsProgress + POSConfigModule.extraProgress;
    }); // const progressValue = ref<number>(0);

    var configLoading = ref(false);
    /**
     * Load pos configs based on the logged in user group
     * And set them to the state
     */

    function loadConfigs() {
      return _loadConfigs.apply(this, arguments);
    }

    function _loadConfigs() {
      _loadConfigs = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading.value = true;
                userGroupId.value = UserModule.getUserGroupId;

                if (!userGroupId.value) {
                  _context.next = 27;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return POSConfigModule.fetchUserConfigs(userGroupId.value);

              case 6:
                _context.next = 8;
                return POSConfigModule.fetchGroupInfo();

              case 8:
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);

                if (!(_context.t0.message.includes(NetworkErrors.NoAccessToken) || _context.t0.message.includes(NetworkErrors.NoSmtzAuthToken))) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("return");

              case 16:
                // unexpected error, show a general response error
                NotificationService.showGeneralResponseError();
                return _context.abrupt("return");

              case 18:
                _context.next = 20;
                return proceedFetchAndStoreGroupPicture();

              case 20:
                ////
                // TODO HAMZA LOCATIONS WORK: the below is only for testing. We need to have a better design for locations logic
                LogService.info("Fetching group cash locations");
                _context.next = 23;
                return DeviceModule.fetchLocations();

              case 23:
                resp = _context.sent;
                LogService.info("Group cash locations pulled, attached.", {
                  params: resp
                });
                _context.next = 42;
                break;

              case 27:
                if (!UserModule.isAdmin) {
                  _context.next = 34;
                  break;
                }

                _context.next = 30;
                return AuthModule.UserLogOut();

              case 30:
                // remove gId parameter if it is set
                if (AppModule.gid) {
                  AppModule.removeGID();
                }

                return _context.abrupt("return");

              case 34:
                hideDialog();
                NotificationService.showCustomError(t("error.no-access-right"));
                _context.next = 38;
                return AuthModule.UserLogOut();

              case 38:
                // remove gId parameter if it is set
                if (AppModule.gid) {
                  AppModule.removeGID();
                }

                _context.next = 41;
                return redirectToLoginPage();

              case 41:
                return _context.abrupt("return");

              case 42:
                // @TODO Riyadh clean next line
                configs.value = POSConfigModule.posConfigs;
                loading.value = false;

              case 44:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10]]);
      }));
      return _loadConfigs.apply(this, arguments);
    }

    function confirmSelectConfig(config) {
      if (POSConfigModule.selectedConfig && config !== POSConfigModule.selectedConfig && hasNonEmptyBookings.value) {
        ElMessageBox.confirm("".concat(this.t("posconfiguration.change-config")), {
          confirmButtonText: "".concat(this.t("common.yes")),
          cancelButtonText: "".concat(this.t("common.return")),
          type: "warning"
        }).then(function () {
          selectConfig(config);
        }).catch(function () {
          ModalModule.setStatus(ModalStatus.Hidden);
        });
      } else {
        selectConfig(config);
      }
    }

    function selectConfig(_x) {
      return _selectConfig.apply(this, arguments);
    }

    function _selectConfig() {
      _selectConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(config) {
        var success;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                loading.value = false;
                configLoading.value = true;
                POSConfigModule.SET_SELECTED_CONFIG(config); // clear the selected grid

                console.log("*********** calling selectGrid 4");
                POSConfigModule.selectGrid(null);
                _context3.next = 7;
                return loadConfigData(config);

              case 7:
                success = _context3.sent;

                if (success) {
                  // Wait for a short delay before hiding the modal
                  setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            // It is sure that every data from remote to start selling is now pulled and stored in local db
                            // lets create a new booking if sales has already started
                            if (hasSalesStarted.value) {
                              console.log("******** calling BookingModule.createNewBooking");
                              BookingModule.createNewBooking();
                            }

                            hideDialog(); // lets reset loading progress

                            POSConfigModule.setPCsLoaded(0);
                            POSConfigModule.setTimeslotsLoaded(0);
                            POSConfigModule.setExtraProgress(0);
                            configLoading.value = true;
                            _context2.next = 8;
                            return pushWithQuery(RouteNames.Booking);

                          case 8:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  })), 500);
                } else {
                  // user is not allowed to sell using selected config
                  configLoading.value = false;
                  loadConfigs();
                }

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _selectConfig.apply(this, arguments);
    }

    return {
      t: t,
      modalVisibility: modalVisibility,
      loadConfigs: loadConfigs,
      userGroupId: userGroupId,
      configs: configs,
      selectConfig: selectConfig,
      loading: loading,
      adminUserWithoutGroup: adminUserWithoutGroup,
      progressValue: progressValue,
      configLoading: configLoading,
      confirmSelectConfig: confirmSelectConfig,
      getLoadingText: getLoadingText
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this.loadConfigs();

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
});